import React, { useEffect, useState, useContext } from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import firebase from "firebase/app";
import { AuthContext } from "../context/AuthContext";
import getSalesItemById from "../requests/getSalesItemById";
import getGigById from "../requests/getGigById";
import editSalesitemById from "../requests/editSalesItemById";
import SalesInputForm from "./SalesInputForm";

const SalesInput = () => {

  const { tourId, gigId, salesId } = useParams();
  const history = useHistory();

  const initialState = {
    itemFields: {
      openingStock: 0,
      numberFreebies: 0,
      numberPaypal: 0,
      closingStock: 0
    },
    gig: {
      date: "",
      venue: "",
      venueCut: 0
    }
  };

  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ itemFields, setItemFields ] = useState(initialState.itemFields);
  const [ productName, setProductName ] = useState("loading...")
  const [ gig, setGig ] = useState(initialState.gig);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function(firebaseUser) {
      if (firebaseUser) {
        setUser(firebaseUser);
        firebaseUser.getIdToken().then(token => {
          setToken(token);
        })
      } else {
        history.push("/login");
      }
    });
  }, [history, setUser, user]);

  useEffect(() => {
    if (token) {
      getSalesItemById(token, salesId).then(response => {
        if (response.status !== 200) {
          history.push(`/tour/${tourId}/gig/${gigId}/sales`);
        }
        const item = response.data[0];
        setProductName(item.productName);
        setItemFields({
          openingStock: item.openingStock,
          numberFreebies: item.numberFreebies,
          numberPaypal: item.numberPaypal,
          closingStock: item.closingStock
        });
      })
    }
  }, [gigId, history, salesId, token, tourId]);

  useEffect(() => {
    if (token) {
      getGigById(token, tourId, gigId).then((response) => {
        setGig(response.data[0]);
      })
    }
  }, [gigId, token, tourId]);

  const handleUpdateSalesItem = (event) => {
    event.preventDefault();
    if (token) {
      editSalesitemById(token, salesId, itemFields)
      .then(response => {
        // console.log(response.status);
        if (response.status === 200) {
          history.push(`/tour/${tourId}/gig/${gigId}/sales`);
        }
      })
      .catch(error => console.log(error));
    }
  }

  const handleFieldChange = (event) => {
    setItemFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  // console.log(item);

  const gigDate = new Date(gig.date).toDateString();

  return (

    <div className="container">
      <Link className="nav-link" to={`/tour/${tourId}/gig/${gigId}/sales`}>Gig sales data</Link>
      <h2 className="heading">Stock / sales input</h2>
      <h3><span className="gig-identifier">venue:</span> {gig.venue}</h3>
      <h3><span className="gig-identifier">date:</span> {gigDate}</h3>

      <SalesInputForm
        handleFieldChange={handleFieldChange}
        handleUpdateSalesItem={handleUpdateSalesItem}
        productName={productName}
        itemFields={itemFields}
      />
      
    </div>

  );

};

export default SalesInput;